import { AgencyTheme } from '../constants/enums/agencyTheme';

export const getTinyMCEEditorTheme = () => {
  const appTheme = +(localStorage.getItem('userThemeReact') || (window as any).REACT_APP_THEME);

  switch (appTheme) {
    case AgencyTheme.Primary:
    case AgencyTheme.Secondary:
    case AgencyTheme.Third:
    case AgencyTheme.Indigo:
    case AgencyTheme.Ocean:
    case AgencyTheme.Platinum:
    case AgencyTheme.BTIS:
      return {};
    case AgencyTheme.Dark:
    case AgencyTheme.Night:
      return {
        skin: 'oxide-dark',
        content_css: 'dark',
      };
    default:
      return {};
  }
};
